"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var core_2 = require("@21st-night/core");
var DeckCategoryEditorItemContainer_1 = __importDefault(require("./DeckCategoryEditorItemContainer"));
var DeckCategoryEditorField_1 = __importDefault(require("./DeckCategoryEditorField"));
var DeckCategoryEditor = function (_a) {
    var deck = _a.deck, variant = _a.variant, other = __rest(_a, ["deck", "variant"]);
    var _b = core_2.useFormField(''), onChange = _b.onChange, value = _b.value, clear = _b.clear;
    var items = variant === 'category' ? deck.categories : deck.subcategories;
    var addItem = react_1.useCallback(function () {
        if (value) {
            if (variant === 'category') {
                deck.addCategory(value);
            }
            else {
                deck.addSubcategory(value);
            }
            clear();
        }
    }, [clear, deck, value, variant]);
    return (react_1.default.createElement("div", __assign({}, other),
        react_1.default.createElement(core_1.List, null,
            items.map(function (item) { return (react_1.default.createElement(DeckCategoryEditorItemContainer_1.default, { key: item, category: item, variant: variant, deck: deck })); }),
            react_1.default.createElement(DeckCategoryEditorField_1.default, { variant: variant, value: value, onChange: onChange, onSubmit: addItem }))));
};
exports.default = DeckCategoryEditor;
//# sourceMappingURL=DeckCategoryEditor.js.map